import store from '@/store';
import { stripNonNumeric } from './stringUtils';
import { APP, USER, UNIT } from './constants';
import enums from './enums';
const { contractValues, contractStatusValues } = enums;
export const hasPermission = (profiles, defaultValue = true) => {
  if (Array.isArray(profiles) && profiles.length > 0) {
    const adminPreviewData = store.getters[APP.GET_ADMIN_PREVIEW];
    if (!adminPreviewData) return defaultValue;
    const { profile } = adminPreviewData;
    return profile ? profiles.includes(profile) : false;
  }
  return defaultValue;
};
export const hasPermittedRole = (roles) => {
  if (Array.isArray(roles) && roles.length > 0) {
    const user = store.getters[USER.GET_USER];
    if (user) {
      return roles.includes(user.userRole);
    }
    false;
  }
  return true;
};

export const contractIsActive = (contract) => {
  const isSyndic = store.getters[UNIT.GET_IS_SYNDIC];
  if (!isSyndic) {
    // isClient
    if (contract.type === contractValues.indirect) {
      return [
        contractStatusValues.indirectActive,
        contractStatusValues.canceled,
      ].includes(contract.status);
    } else if (
      [contractValues.buyAndSell, contractValues.cession].includes(
        contract.type
      )
    ) {
      return [
        contractStatusValues.active,
        contractStatusValues.settled,
      ].includes(contract.status);
    }
    return false;
  }
  return true;
};

export const getUnitProposersInfo = (selectedUnit, property) => {
  const result = [];
  const user = store.getters[USER.GET_USER];
  if (user) {
    for (const contract of selectedUnit.contracts) {
      if (contractIsActive(contract)) {
        for (const proposer of contract.proposers) {
          if (!result.includes(property ? proposer[property] : proposer)) {
            if (user.username === stripNonNumeric(proposer.document)) {
              result.unshift(property ? proposer[property] : proposer);
            } else {
              result.push(property ? proposer[property] : proposer);
            }
          }
        }
      }
    }
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/utils/index.js